import { createContext } from "react";
import type { Transaction } from "features/transactions/types";

export const TransactionContext = createContext<Transaction>({} as Transaction);

const TransactionProvider = TransactionContext.Provider;

export default TransactionProvider;
